/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Flex,
  ProgressCircle,
  Tabs,
  Item,
  TabList,
  TabPanels,
} from '@adobe/react-spectrum';
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';
import MainContainer, { Label, SubComment, NoComment } from './CommentStyle';
import Comments from './Comments';
import AddComment from './AddComment';

const RecentReviewComments = ({ projectID, taskID, userEmail }) => {
  const [commentsData, setCommentsState] = useState({
    isLoading: true,
    data: [],
  });
  const [count, setCount] = useState(5);
  const [isTaskComment, setTaskComment] = useState(false);
  const [isAddComment, setAddComment] = useState(false);

  function getQueryParams() {
    let queryParams;
    if (projectID) {
      queryParams = {
        projectID,
        entryDate_Sort: 'desc',
      };
    } else if (taskID) {
      queryParams = {
        taskID,
        entryDate_Sort: 'desc',
      };
      setTaskComment(true);
    }
    return queryParams;
  }

  async function getNotes() {
    setCommentsState({ ...commentsData, isLoading: true });
    const fields = [
      'ID',
      'owner:name',
      'project:name',
      'noteText',
      'subject',
      'entryDate',
      'parentNoteID',
      'replies:noteText',
      'replies:owner:name',
      'replies:entryDate',
      'documentID',
      'proofID',
      'json',
    ];
    const queryParams = getQueryParams();
    const actionResponse = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.NOTE_SEARCH, queryParams, fields },
    );
    if (actionResponse) {
      const filteredCommentData = actionResponse.filter(
        element => element.noteText && !element.parentNoteID,
      );
      setCommentsState({
        ...commentsData,
        data: filteredCommentData,
        view: 'NOTE',
        isLoading: false,
      });
    } else {
      setCommentsState({
        ...commentsData,
        isLoading: false,
      });
    }
  }

  const handleLoadMore = commentData => {
    const limit = 5;
    if (count < commentData) setCount(count + limit);
  };

  useEffect(() => {
    if (projectID || taskID) {
      getNotes();
    } else {
      setCommentsState({
        ...commentsData,
        isLoading: false,
      });
    }
  }, [projectID, taskID, isAddComment]);

  return (
    <MainContainer>
      <h3 className="mainTitle">{`Recent Review Comments (${
        commentsData?.data?.length || 0
      })`}</h3>
      <>
        {isTaskComment ? (
          ''
        ) : (
          <>
            <Label>Project Comments</Label>
            <SubComment>
              {commentsData?.data[0]?.project?.name || ''}
            </SubComment>{' '}
          </>
        )}
        <AddComment
          projectID={projectID}
          taskID={taskID}
          userEmail={userEmail}
          isAddComment={isAddComment}
          setAddComment={setAddComment}
        />
        <Tabs aria-label="Chat log quiet example">
          <TabList>
            <Item key="item1">New Updates</Item>
          </TabList>
          <TabPanels />
        </Tabs>
      </>
      {!commentsData.isLoading ? (
        <>
          {commentsData?.data[0] ? (
            ''
          ) : (
            <NoComment>No comments found</NoComment>
          )}
          {commentsData?.data?.slice(0, count).map(element => (
            <Comments
              key={element.ID}
              ID={element.ID}
              isTaskComment={isTaskComment}
              taskID={taskID}
              documentID={element.documentID}
              workfrontEndpoint={element.workfrontEndpoint}
              project={element.project}
              entryDate={element.entryDate}
              owner={element.owner}
              commentNote={element.noteText}
              proofId={element.proofID}
              replies={element.replies}
              commentRichText={element.json}
            />
          ))}
          {commentsData?.data.length > count ? (
            <Button
              top="20px"
              left="7%"
              onPress={() => handleLoadMore(commentsData.data.length)}
            >
              View more
            </Button>
          ) : (
            ''
          )}
        </>
      ) : (
        <Flex justifyContent="center" marginY="size-1000">
          <ProgressCircle aria-label="Loading…" size="L" isIndeterminate />
        </Flex>
      )}
    </MainContainer>
  );
};

export default RecentReviewComments;
